import {
  ChatBubbleOutline as MessageCircleIcon,
  Send as SendIcon,
  PersonAdd as UserPlusIcon,
  Person as UserCheckIcon,
  Instagram as InstagramIcon,
  Facebook as FacebookIcon,
  Tag as HashIcon,
  AccessTime as ClockIcon,
  FormatListBulleted as ListChecksIcon,
  Settings as Settings2Icon,
  SmartToy as VaanikIcon,
} from '@mui/icons-material';

export const TEMPLATE_ORDER = ['comment_reply', 'comment_dm', 'dm_reply', 'custom'];

export const TRIGGER_CHANNELS = [
  { value: 'instagram_comment', label: 'Instagram Comment' },
  { value: 'instagram_dm', label: 'Instagram DM' },
  { value: 'facebook_comment', label: 'Facebook Comment' },
  { value: 'facebook_messenger', label: 'Facebook Messenger' },
];

export const MATCH_RULES = [
  { value: 'contains_any', label: 'Contains any keyword' },
  { value: 'contains_all', label: 'Contains all keywords' },
];

/** Primary SMA API paths; LMS paths kept as fallback during rollout. */
export const API_PATHS = {
  autoReply: ['/sma/auto-reply/', '/lms/integrations/facebook/auto-reply/'],
  replyTemplates: ['/sma/reply-templates/', '/lms/integrations/facebook/reply-templates/'],
  testTemplate: ['/sma/reply-templates/test/', '/lms/integrations/facebook/reply-templates/test/'],
};

export const TEMPLATE_META = {
  comment_reply: {
    trigger: 'Instagram Comment',
    triggerIcon: MessageCircleIcon,
    actionLabel: 'Public comment reply',
    actionTint: 'rgba(0, 112, 80, 0.08)',
    flowHint: 'Step 1 — reply on every comment (no keyword rules)',
  },
  comment_dm: {
    trigger: 'After comment reply',
    triggerIcon: SendIcon,
    actionLabel: 'Direct message',
    actionTint: '#FFEDE7',
    flowHint: 'Step 2 — DM sent right after comment reply',
  },
  dm_reply: {
    trigger: 'Instagram DM',
    triggerIcon: InstagramIcon,
    actionLabel: 'Auto reply',
    actionTint: 'rgba(0, 112, 80, 0.08)',
    flowHint: 'Incoming message auto-reply',
  },
  custom: {
    trigger: 'Keyword match',
    triggerIcon: HashIcon,
    actionLabel: 'Custom automation',
    actionTint: '#FEF3C7',
    flowHint: 'Runs when comment or DM text matches your keywords',
  },
};

export function getLibraryItemById(itemId) {
  for (let g = 0; g < NODE_LIBRARY.length; g += 1) {
    const found = NODE_LIBRARY[g].items.find((item) => item.id === itemId);
    if (found) return found;
  }
  return null;
}

export const TAB_ITEMS = [
  { id: 'list', label: 'Automations', icon: ListChecksIcon },
  { id: 'settings', label: 'Advanced settings', icon: Settings2Icon },
];

export { VaanikIcon };

export const NODE_LIBRARY = [
  {
    group: 'Triggers',
    items: [
      { id: 'ig-comment', label: 'Instagram Comment', icon: InstagramIcon, kind: 'trigger' },
      { id: 'ig-dm', label: 'Instagram DM', icon: InstagramIcon, kind: 'trigger' },
      { id: 'fb-comment', label: 'Facebook Comment', icon: FacebookIcon, kind: 'trigger' },
      { id: 'messenger', label: 'Facebook Messenger', icon: MessageCircleIcon, kind: 'trigger' },
    ],
  },
  {
    group: 'Logic',
    items: [
      { id: 'keyword', label: 'Keyword Match', icon: HashIcon, kind: 'logic' },
      { id: 'working-hours', label: 'Working Hours', icon: ClockIcon, kind: 'logic' },
    ],
  },
  {
    group: 'Actions',
    items: [
      { id: 'reply', label: 'Reply to Comment', icon: MessageCircleIcon, kind: 'action' },
      { id: 'dm', label: 'Send DM', icon: SendIcon, kind: 'action' },
      { id: 'lead', label: 'Create Lead', icon: UserPlusIcon, kind: 'action' },
      { id: 'assign', label: 'Assign Agent', icon: UserCheckIcon, kind: 'action' },
      { id: 'vaanik', label: 'Vaanik Agent', icon: VaanikIcon, kind: 'action' },
    ],
  },
];
